// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wd6JA","productName":"Table_productName__JFz7V"};